import React, { useState, useEffect } from "react";
import ApiService from "../../services/ApiService";
import {
  formatDatestring,
  getDisplayDateFromStartEndDateString,
  getNumPostfix,
  randomString,
} from "../../utils";
import { toast } from "react-hot-toast";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { countries } from "../../countries";
import Footer from "../../Base/Footer";

const eventTitle = `Cannes 2025`;

export default function Request({ event }) {
  const [isShown, setIsShown] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [ref, inView] = useInView({
    triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
  });

  const [form, setForm] = useState({
    options: [],
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    email: "",
    city: "",
    // country: "United States",
    country: "",
    businessGoals: "",
    referredBy: "",
    partners: [],
  });
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const partnerOnChange = (e) => {
    if (e.target.checked) {
      let arr = [...form.partners];
      arr.push(e.target.id);
      updateForm({ partners: arr });
    } else {
      updateForm({
        partners: form.partners.filter((item) => item !== e.target.id),
      });
    }
  };

  const clearForm = () => {
    setForm({
      options: [],
      firstName: "",
      lastName: "",
      company: "",
      jobTitle: "",
      email: "",
      city: "",
      // country: "United States",
      country: "",
      businessGoals: "",
      referredBy: "",
      partners: [],
    });
  };

  const submitForm = async () => {
    if (!formValid) {
      console.log(`submitForm() - form is invalid`, form);
      return;
    }
    form.eventId = event.eventId;
    form.optionRequests = form.options;
    console.log(`submitForm()`, form);
    try {
      const api = new ApiService();
      const response = await api.post(`landmark/events/submitGlobalEventRsvp`, {
        form,
      });
      console.log(`submitForm() - response`, response);
      if (response && response.success) {
        setTimeout(() => {
          // toast.success("Your response has been logged. Thank you!");
          setIsShown(true);
          setSubmitError(false);
          clearForm(); // clear inputs
        }, 50);
      } else {
        throw "Error submitting form";
      }
      // setEvents(response);
    } catch (error) {
      setIsShown(false);
      setSubmitError(true);
      console.error("Error submitting form", error);
      toast.error("An error occurred when submitting your response.");
    }
  };

  console.log(`event`, event);

  if (!event || !event.eventId) {
    return null;
  }

  let formValid = false;
  let formErrorMsg = ``;
  // validate form
  const validateForm = () => {
    const {
      options,
      firstName,
      lastName,
      company,
      jobTitle,
      email,
      city,
      country,
      businessGoals,
      referredBy,
      partners,
    } = form;
    // must select at least 1 options event
    if (!options.length) {
      formErrorMsg = "Please select at least one event";
      return false;
    }
    if (!firstName.length) {
      formErrorMsg = "Please enter your first name";
      return false;
    }
    if (!lastName.length) {
      formErrorMsg = "Please enter your last name";
      return false;
    }
    if (!company.length) {
      formErrorMsg = "Please enter your company";
      return false;
    }
    if (!jobTitle.length) {
      formErrorMsg = "Please enter your job title";
      return false;
    }
    // if (!city.length) {
    //   formErrorMsg = "Please enter your city";
    //   return false;
    // }
    // if (!country.length) {
    //   formErrorMsg = "Please select your country";
    //   return false;
    // }
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!email.length || !emailRegex.test(email)) {
      formErrorMsg = "Please enter a valid email address";
      return false;
    }
    return true;
  };
  formValid = validateForm();
  const submitDisabledClass = formValid ? "" : "disabled";

  const PartnerGrid = ({ indexMin, indexMax }) => {
    const [ref, inView] = useInView({
      triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
    });
    const images = [];
    for (let i = indexMin; i <= indexMax; i++) {
      images.push(
        process.env.PUBLIC_URL + `/images/unga/sponsors/centered/${i}.png`
      );
    }
    return (
      <div className="gallery">
        {images.map((srcUrl, index) => (
          <motion.div
            className="gallery-item"
            ref={ref}
            initial={{ opacity: 0, x: 50 }} // Set your initial state
            animate={inView ? { opacity: 1, x: 0 } : {}} // Set your animation properties
            transition={{ duration: 0.7, ease: "easeOut", delay: index * 0.05 }} // Add delay based on index
            key={index} // Add key for list item
          >
            <img
              className="img-fluid"
              key={index}
              src={srcUrl}
              alt={`Sponsor`}
            />
          </motion.div>
        ))}
      </div>
    );
  };

  return (
    <>
      {/* <div className="cap-width">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, x: 20, y: 0 }} // Set your initial state
          animate={inView ? { opacity: 1, y: 0, x: 0 } : {}} // Set your animation properties
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <div></div>
        </motion.div>
        <div className="options-list">
          <div className="option-container top" style={{ minHeight: "unset" }}>
            <div
              className="option-header"
              style={{
                borderRadius: "8px",
                minHeight: "50px",
                marginTop: "50px",
              }}
            ></div>
          </div>
          <div className="option-heading-text">
            To request an invitation to your preferred events, please select one
            or more from the list below:
          </div>
        </div>
      </div> */}
      <div className="grey-bg-section">
        <div className="options-list cap-width">
          {event && event.options.length
            ? event.options.map((item, index) => {
                return (
                  <RequestEventOption
                    itemData={item}
                    key={index}
                    updateForm={updateForm}
                    form={form}
                  />
                );
              })
            : null}
        </div>
      </div>
      <div className="cap-width slightly-wider">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 0 }} // Set your initial state
          animate={inView ? { opacity: 1, y: 0 } : {}} // Set your animation properties
          transition={{ duration: 1.4, ease: "easeOut" }}
        >
          <div className="form-container" id="apply">
            <div className="requestForm">
              <h3>REQUEST AN INVITATION</h3>
              {event && event.options.length
                ? event.options.map((item, index) => {
                    return (
                      <RequestEventOption
                        checkboxMode={true}
                        itemData={item}
                        key={index}
                        updateForm={updateForm}
                        form={form}
                      />
                    );
                  })
                : null}
              <h3 style={{ marginTop: "40px" }}>Your Information</h3>
              <div className="requestForm__inputs">
                <label className="input__outer sm">
                  <h5>First Name</h5>
                  <div className="input">
                    <input
                      type="name"
                      value={form.firstName}
                      onChange={onChangeInput("firstName")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Last Name</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.lastName}
                      onChange={onChangeInput("lastName")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Company</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.company}
                      onChange={onChangeInput("company")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Job title</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.jobTitle}
                      onChange={onChangeInput("jobTitle")}
                    />
                  </div>
                </label>
                {/* <label className="input__outer sm">
                  <h5>City</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.city}
                      onChange={onChangeInput("city")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Country</h5>
                  <div className="input">
                    <select
                      value={form.country}
                      onChange={onChangeInput("country")}
                    >
                      <option value="" disabled>
                        Select a country
                      </option>
                      {countries.map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                </label> */}
                <label className="input__outer sm">
                  <h5>Email</h5>
                  <div className="input">
                    <input
                      type="email"
                      value={form.email}
                      onChange={onChangeInput("email")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Referred By (optional)</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.referredBy}
                      onChange={onChangeInput("referredBy")}
                    />
                  </div>
                </label>
                <label className="input__outer">
                  <h5>Tell us about your business goals (optional)</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.businessGoals}
                      onChange={onChangeInput("businessGoals")}
                    />
                  </div>
                </label>
              </div>

              {/* <div
                className="option-header"
                style={{
                  borderRadius: "8px",
                  minHeight: "46px",
                  marginBottom: "40px",
                  marginTop: "20px",
                }}
              ></div>
              <h3 style={{ marginBottom: "7px" }}>WANT TO PARTNER?</h3>

              <h5 className="partner-text">
                Let's discuss! We welcome the opportunity to collaborate with
                partners at UNGA 2024 and beyond including our annual Flagship
                Summit. Let us know if you would be interested in any of the
                following:
              </h5> */}

              {/* <label htmlFor="partnerEventSponsorship" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerEventSponsorship"
                    checked={form.partners.some(
                      (p) => p === "partnerEventSponsorship"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to discuss an annual SIS Sponsorship
                </div>
              </label>
              <label htmlFor="partnerCustomEvent" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerCustomEvent"
                    checked={form.partners.some(
                      (p) => p === "partnerCustomEvent"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to discuss hosting a custom event at UNGA 2024 or
                  another time of year
                </div>
              </label>
              <label htmlFor="partnerIndustryTrendsBriefing" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerIndustryTrendsBriefing"
                    checked={form.partners.some(
                      (p) => p === "partnerIndustryTrendsBriefing"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to schedule an Impact Trends Briefing with{" "}
                  <a
                    target="_blank"
                    className="purple-link"
                    href="https://www.sisomni.com/"
                  >
                    SIS Omni
                  </a>
                </div>
              </label> */}
              <div className="requestForm submit">
                {!isShown && (
                  <div className="submit-wrapper">
                    <button
                      type="submit"
                      onClick={submitForm}
                      className={`button pink-btn ${submitDisabledClass}`}
                    >
                      SUBMIT
                    </button>
                    {formErrorMsg.length ? (
                      <div className="form-invalid-msg text-center">
                        {formErrorMsg}
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
              <AnimatePresence>
                {/* {isShown && <SuccessModal setIsShown={setIsShown} />} */}
                {isShown && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <div className="submit-success-msg">
                      Thank you for your application to join our Landmark 2025
                      Events Series @ Cannes!
                      {/* <br></br>
                      All of our events are currently at capacity, and you have
                      been added to the waitlist.
                      <br></br>
                      If a spot opens up, the team will be in touch with a
                      confirmation including all logistic details. */}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
              <AnimatePresence>
                {submitError && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <div className="submit-success-msg">
                      There was an error when submitting your form. <br />
                      Please reach out to <b>scui@landmarkventures.com</b> and
                      he will add your application.
                      <br />
                      Sorry for the inconvenience.
                      {/* <br></br>
                      All of our events are currently at capacity, and you have
                      been added to the waitlist.
                      <br></br>
                      If a spot opens up, the team will be in touch with a
                      confirmation including all logistic details. */}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </div>
      {/* <div className="cap-width">
        <div className="partners-section">
          <h3
            className="partners-title"
            style={{ marginBottom: "7px", textAlign: "center" }}
          >
            Thank You to our Annual Sponsors
          </h3>
          <div className="inner">
            <div className="header-img">
              <div className="header-img-text">2024 PRESENTING PARTNERS</div>
            </div>
            <PartnerGrid indexMin={1} indexMax={3} />

            <div className="header-img">
              <div className="header-img-text">2024 FEATURED PARTNERS</div>
            </div>
            <PartnerGrid indexMin={4} indexMax={12} />

            <div className="header-img">
              <div className="header-img-text">2024 SUPPORTING PARTNERS</div>
            </div>
            <PartnerGrid indexMin={13} indexMax={30} />
          </div>
        </div>
      </div> */}

      <div className="footer-section" style={{ marginTop: "70px" }}></div>
      <div className="ed-footer">
        <Footer alternate={true} />
      </div>
      {/* <div className="disclaimer">
        Landmark Events are not affiliated with CES®
      </div> */}
      {/* <div style={{ height: "400px" }}></div> */}
    </>
  );
}

const RequestEventOption = (props) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
  });
  const [checked, setChecked] = useState(false);
  const onChange = (e) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      let arr = [...props.form.options];
      arr.push(props.itemData.optionId);
      props.updateForm({ options: arr });
      console.log(
        `RequestEventOption() - form options updated - option event added`,
        arr
      );
    } else {
      const adjustedArr = props.form.options.filter(
        (item) => item !== props.itemData.optionId
      );
      props.updateForm({
        options: adjustedArr,
      });
      console.log(
        `RequestEventOption() - form options updated - option event removed`,
        adjustedArr
      );
    }
  };

  let redesignMode = true;
  let checkboxMode = props.checkboxMode || false;

  const randomId = randomString(6);

  // don't show hidden options
  if (props.itemData.hidden) {
    return null;
  }

  // for the bottom form
  if (props.checkboxMode) {
    // console.log(`props.itemData.timeString`, props.itemData.timeString);
    // console.log(`props.itemData.dateString`, props.itemData.dateString);

    function removeLastSegment(inputString) {
      // Check if the input is a non-empty string
      if (typeof inputString !== "string" || inputString.trim() === "") {
        return ""; // Return an empty string for invalid input
      }

      // Split the string by whitespace
      const segments = inputString.split(/\s+/);

      // Check if there are at least two segments to remove the last one
      if (segments.length <= 1) {
        return ""; // Return an empty string if there are no segments to remove
      }

      // Remove the last element (segment) and join the remaining segments back into a string
      const result = segments.slice(0, -1).join(" ");

      return result.trim(); // Trim any extra whitespace
    }

    return (
      <label htmlFor={randomId} className="check">
        <div className="check__box">
          <input
            type="checkbox"
            id={randomId}
            checked={checked}
            onChange={onChange}
          />
          <span>
            <img
              src={process.env.PUBLIC_URL + "/images/icons/tick-white.svg"}
              alt="icon"
            />
          </span>
        </div>
        {props.itemData.optionId === "733a6c7b" && (
          <div className="check-label">{props.itemData.title}</div>
        )}
        {props.itemData.optionId !== "733a6c7b" && (
          <div className="check-label">
            {`${formatDatestring(props.itemData.dateString, {
              shortDay: true,
            })} | ${removeLastSegment(props.itemData.timeString)}`}
            <span className="hide-mob">{` | `}</span> {/* &nbsp */}
            <div
              className="show-mob"
              style={{ width: "100%", height: "8px" }}
            ></div>
            {`${props.itemData.title}`}
          </div>
        )}
      </label>
    );
  }

  if (redesignMode) {
    let [titlePrefix, title] = props.itemData.title.split(":");
    if (!title) {
      title = titlePrefix;
      titlePrefix = null;
    }
    const shortTitle = props.itemData.shortTitle;
    const hasLogo = props.itemData.logos && props.itemData.logos.length;
    // (props.itemData.logos[0].endsWith(".png") ||
    //   props.itemData.logos[0].endsWith(".jpg") ||
    //   props.itemData.logos[0].endsWith(".jpeg"));

    // Split the description by newline character
    const paragraphs = props.itemData.description.split("\n");

    // Helper function to convert text with custom URL format to HTML with <a> tags
    const convertToLinks = (text) => {
      // Regular expression to match [URL=link]text[/URL]
      const urlPattern = /\[URL=(https?:\/\/[^\]]+)\](.*?)\[\/URL\]/gi;

      // Replace the custom format with HTML <a> tags
      const htmlText = text.replace(urlPattern, (match, url, hyperlink) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${hyperlink}</a>`;
      });

      return { __html: htmlText }; // Return as a raw HTML object
    };

    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0, x: 20, y: 0 }} // Set your initial state
        animate={inView ? { opacity: 1, y: 0, x: 0 } : {}} // Set your animation properties
        transition={{ duration: 0.9, ease: "easeOut" }}
      >
        <div className="option-container">
          <div className="option-header logo">
            {props.itemData.optionId === "733a6c7b" && (
              <div className="bottom">
                <div className="img-container no-mt">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )}
            {props.itemData.optionId === "733a6c7b" && (
              <div className="top mt">
                <div className="text">1 : 1 STRATEGY SESSION WITH LANDMARK</div>
              </div>
            )}
            {props.itemData.optionId === "7d153550" && (
              <div className="top">
                {titlePrefix ? (
                  <div className="text prefix">{titlePrefix}</div>
                ) : null}

                <div className="text">{title}</div>
                {shortTitle ? (
                  <div className="text postfix">{shortTitle}</div>
                ) : null}
              </div>
            )}
            {props.itemData.optionId === "5fa4142a" && (
              <div className="top">
                {/* <div className="text prefix">Why Most Brands Miss the Mark</div> */}

                <div className="text prefix">ADTECH BREAKFAST</div>

                <div className="text">
                  {`Why Most Brands Miss the Mark – How to Connect Audience
                  Research, Data, and Media for Smarter Campaigns`.toUpperCase()}
                </div>

                {/* <div className="text prefix">ADTECH BREAKFAST</div>
                <div className="text">
                  SEEING THE FULL PICTURE: WHERE DATA, MEDIA, AND BRAND VISION
                  ALIGN
                </div> */}
                {shortTitle ? (
                  <div className="text postfix">{shortTitle}</div>
                ) : null}
              </div>
            )}

            {props.itemData.optionId === "7d153550" && (
              <div className="bottom">
                <div className="img-container">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/ryff.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/verve.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )}
            {props.itemData.optionId === "5fa4142a" && (
              <div className="bottom">
                <div className="img-container">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img bmm`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/bmm.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="option-body">
            <div className="upper-container">
              <div className="date-time-container">
                <div className="date">
                  {props.itemData.dateString
                    .replace(", 2025", "")
                    .toUpperCase()}
                </div>
                <div className="date">
                  {props.itemData.timeString
                    .replace("pm PT", " PM")
                    .replace("am PT", " AM")}
                </div>
              </div>
              <div className="date-time-container text-center">
                {props.itemData.subLocation && (
                  <div className="date location">
                    {props.itemData.subLocation}
                  </div>
                )}
                <div className="date location">{props.itemData.location}</div>
              </div>
            </div>
            {props.itemData.optionId === "7d153550" && (
              <div className="description">
                <p>
                  Join us for a private, invite-only lunch during Cannes Lions,
                  focused on the rapid evolution of CTV and the rise of in-scene
                  brand integration and virtual product placement. Coordinated
                  by Landmark and Co-hosted by Ryff and Verve, this 35-person
                  gathering offers a relaxed, off-the-croisette experience
                  designed for agency leaders, brand marketers, adtech execs,
                  corp dev teams, and strategic investors.
                </p>

                <p>
                  <strong>Panel Speakers:</strong>
                </p>
                <ul>
                  <li>
                    <span className="bullet">•</span>{" "}
                    <strong>Shirley Hughes</strong>, Head of Global Sales &amp;
                    Customer Experience, Ryff
                  </li>
                  <li>
                    <span className="bullet">•</span>{" "}
                    <strong>Grant Gudgel</strong>, SVP Marketing, Verve
                  </li>
                  <li>
                    <span className="bullet">•</span>{" "}
                    <strong>Linda Cronin</strong>, Chief Media Officer, Monks
                    Agency
                  </li>
                  <li>
                    <span className="bullet">•</span> Moderated by{" "}
                    <strong>Tom Triscari</strong>, Landmark Ventures &amp; Quo
                    Vadis Newsletter (Moderator)
                  </li>
                </ul>

                <p>
                  <strong>Why This Matters:</strong>
                </p>
                <p className="no-mt">
                  We’re seeing strong momentum and high partner engagement
                  around in-scene advertising, with Ryff emerging as a category
                  leader in AI-powered virtual product placement. As budgets
                  shift from the open web (where quality and impact are eroding)
                  to CTV, the need for innovation is clear. Success in this next
                  chapter depends on formats that go beyond standard pre-roll
                  and overlays, unlocking premium inventory and deeper brand
                  experiences. Ryff and Verve are deeply focused in this area
                  and look forward to sharing their thoughts and engaging with
                  industry leaders on this topic.
                </p>

                <p>
                  <strong>Note:</strong> Landmark has partnered with Verve and
                  can extend an invite to their “Daily Recharge Happy Hour” from
                  5-7pm throughout the week at Chez Verve -{" "}
                  <a
                    href="https://chezvervecannes.splashthat.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://chezvervecannes.splashthat.com/
                  </a>
                </p>
              </div>
            )}

            {props.itemData.optionId === "5fa4142a" && (
              <div className="description">
                <p>
                  81% of audiences aren’t seeing ads that are relevant to them.
                  Too many brands rely on guesswork to target audiences and
                  craft their campaign creatives.
                </p>
                <p>
                  There’s a better way. It’s time to stop the leaps of faith and
                  start getting results.
                </p>
                <p>
                  Join Bright Mountain CEO Matt Drinkwater, Landmark Ventures’
                  Tom Triscari and John Kunschner, and Michael Beebe, CEO of
                  Dstillery, for a candid beachfront breakfast conversation on
                  what really moves the needle - and what doesn't - in today’s
                  omnichannel marketing landscape.
                </p>
                <p>
                  This intimate panel unpacks how a connected audience strategy,
                  powered by proprietary research and full-funnel execution,
                  helped Aruba drive measurable impact with its brand
                  storytelling. Expect real examples, hard truths, and a new way
                  to think about aligning your data, media, and creative
                  strategy - not in silos, but as a single, audience-first
                  engine for growth.
                </p>
                <p>
                  Are you building a better campaign - or just buying more
                  impressions? Join us to find out.
                </p>
                {/* <p>
                  <strong>Session Focus:</strong>
                </p>
                <ul>
                  <li>
                    <span className="bullet">•</span> Data driven media buying
                    and brand storytelling strategies to drive advertiser
                    outcomes
                  </li>
                  <li>
                    <span className="bullet">•</span> Strategic deal sourcing &
                    direct post-session engagement
                  </li>
                </ul> */}

                {/* <p>
                  <strong>Why This Matters:</strong>
                </p>
                <p className="no-mt">
                  With deal volume compressing and buyer selectivity increasing,
                  the need for founder preparedness and smart navigation is more
                  important than ever. This session is designed to surface
                  actionable insight and connection - providing corp dev teams
                  with direct access to high-intent, high-potential founders,
                  and giving founders a clearer sense of today’s strategic
                  landscape.
                </p> */}
              </div>
              //   <div className="description">
              //   <p>
              //     Join Tom Triscari and John Kunschner from Landmark Ventures
              //     and Matt Drinkwater, the CEO of Bright Mountain Media, for a
              //     beachfront breakfast and panel conversation.
              //   </p>
              //   <p>
              //     Hosted by BMTM CEO Matt Drinkwater, the session will explore
              //     how market research and proprietary data from its Big Village
              //     business unifies media buying strategies to deliver more
              //     effective outcomes for advertisers. This intimate conversation
              //     is designed to engage senior leaders from large agencies,
              //     independent shops, and forward-thinking brands seeking to
              //     connect insights with impact.
              //   </p>
              //   <p>
              //     In addition, for adtech companies seeking strategic
              //     partnership to amplify your amazing media, creative, or data
              //     tech, Bright Mountain Media is in an acquisitive state of
              //     mind. Come to our breakfast, absorb our strategic context, and
              //     meet Matt. Everything good starts with a conversation, and
              //     there is no better place in the advertising business than
              //     Cannes Lions.
              //   </p>
              //   <p>
              //     <strong>Session Focus:</strong>
              //   </p>
              //   <ul>
              //     <li>
              //       <span className="bullet">•</span> Data driven media buying
              //       and brand storytelling strategies to drive advertiser
              //       outcomes
              //     </li>
              //     <li>
              //       <span className="bullet">•</span> Strategic deal sourcing &
              //       direct post-session engagement
              //     </li>
              //   </ul>

              //   {/* <p>
              //     <strong>Why This Matters:</strong>
              //   </p>
              //   <p className="no-mt">
              //     With deal volume compressing and buyer selectivity increasing,
              //     the need for founder preparedness and smart navigation is more
              //     important than ever. This session is designed to surface
              //     actionable insight and connection - providing corp dev teams
              //     with direct access to high-intent, high-potential founders,
              //     and giving founders a clearer sense of today’s strategic
              //     landscape.
              //   </p> */}
              // </div>
            )}

            {props.itemData.optionId === "733a6c7b" && (
              <div className="description no-pt">
                <p>
                  We’ll also be available for scheduling a select number of 1 :
                  1 meetings with Landmark’s team (John Kunschner – Managing
                  Director & Tom Triscari – Senior Advisor, Adtech & Media)
                  throughout the week - perfect for zeroing in on active M&A
                  mandates, partnership conversations, or strategic roadmap
                  alignment.  
                </p>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    );
  }

  if (checkboxMode) {
    return (
      <div className="req-item extended">
        <div className="req-item-content alt">
          <div className="req-item-upper">
            <div className="check__box adj">
              <input
                type="checkbox"
                id={randomId}
                checked={checked}
                onChange={onChange}
              />
              <span>
                <img
                  src={process.env.PUBLIC_URL + "/images/icons/tick-white.svg"}
                  alt="icon"
                />
              </span>
            </div>
            {/* <div className="req-item-img">
              <img className="img-fluid" src={props.itemData.imageUrl} />
            </div> */}
            <div
              onClick={() => {
                const e = { target: { checked: !checked } };
                onChange(e);
              }}
              className="req-item-header"
            >
              <h5>{props.itemData.title}</h5>
              <p className="sm short-desc">
                <span>{props.itemData.timeString}</span>
                <span className="divider">{` | `}</span>
                <span>{props.itemData.location}</span>
              </p>
              <p className="sm long-desc">{props.itemData.description}</p>
            </div>
          </div>
          {/* <div className="req-item-lower">
        </div> */}
        </div>
      </div>
    );
  }
  return null;
  // return (
  //   <div className="req-item">
  //     <input type="checkbox" checked={checked} onChange={onChange} />
  //     <div className="req-item-content">
  //       <div className="req-item-upper">
  //         <div className="req-item-img">
  //           <img className="img-fluid" src={props.itemData.imageUrl} />
  //         </div>
  //         <div className="req-item-header">
  //           <h5>{props.itemData.title}</h5>
  //           <p className="sm short-desc">{props.itemData.shortDescription}</p>
  //           <p className="sm long-desc">{props.itemData.longDescription}</p>
  //         </div>
  //       </div>
  //       {/* <div className="req-item-lower">
  //       </div> */}
  //     </div>
  //   </div>
  // );
};
